import { ResidentMedicationsTemplate } from "app/features/medications/templates/ResidentMedicationsTemplate";

export default function MedicationLogsPage() {
  return <ResidentMedicationsTemplate />;
}
